const GET_USER_PIN_OPTIONS_PATH = '/v2/user-pins/options';
function get_user_pin_options_path() {
    return GET_USER_PIN_OPTIONS_PATH;
}
export { GET_USER_PIN_OPTIONS_PATH, get_user_pin_options_path };
